module.exports = __webpack_public_path__ + "static/20200811_111457-eab6f16236812b2f0b1f143a960af9e0.jpg";